import { Image } from '@mantine/core';

type IconGunProps = {
  width?: number;
  height?: number;
  color?: 'default' | 'active';
};

export const IconGun = ({ width = 24, height = 24, color = 'default' }: IconGunProps) => {
  return (
    <Image
      src={color === 'default' ? '/images/gun.png?v=2' : '/images/gun-active.png?v=2'}
      alt="Gun"
      width={width}
      height={height}
      fit='contain'
    />
  );
};